import { render, staticRenderFns } from "./GradeQuery.vue?vue&type=template&id=8765fc6c&scoped=true"
import script from "./GradeQuery.vue?vue&type=script&lang=js"
export * from "./GradeQuery.vue?vue&type=script&lang=js"
import style0 from "./GradeQuery.vue?vue&type=style&index=0&id=8765fc6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8765fc6c",
  null
  
)

export default component.exports